<template>
  <v-card
    elevation="0"
    class="filter-group"
  >
    <v-row align="center">
      <v-col
        cols="12"
        sm="4"
        lg="2"
        class="pr-0 pb-0 pb-sm-3"
      >
        <MultipleSelectFilter
          label="Organizations"
          filterKey="org"
          url="cart/organization"
          :selected="selected['org']"
          :is-immediately="true"
          @select="select"
          search
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
        lg="2"
        class="pr-0 pb-0 pb-sm-3"
      >
        <MultipleSelectFilter
          label="Networks"
          filterKey="network"
          url="cart/network"
          :selected="selected['network']"
          :is-immediately="true"
          @select="select"
          search
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="4"
        class="pr-0 pb-0 pb-sm-3"
      >
        <v-switch
          v-model="selected.showOrgsWithNoDevices"
          @change="showOrgsWithNoDevices()"
          label="Show organizations with no devices"
        ></v-switch>
      </v-col>

      <v-col
        cols="12"
        sm="4"
        lg="2"
        class="d-flex align-center"
        v-if="includeAdvancedFilters"
      >
        <v-btn
          color="secondary"
          class="button--text"
          tile
          @click="showFilterDialog"
        >
          <v-icon>mdi-filter-variant-plus </v-icon>
          {{ advancedFilterCount ? `Advanced Filter (${advancedFilterCount})` : 'Advanced Filter' }}
        </v-btn>
      </v-col>
    </v-row>
    <div class="additional-option-wrapper">
      <v-btn
        class="text-capitalize px-0"
        plain
        @click="resetFilter"
        v-if="isFilterSelected"
      >
        Reset Filter
      </v-btn>
    </div>
    <v-dialog
      v-model="filterDialog"
      persistent
      max-width="700px"
    >
      <v-card>
        <v-toolbar class="elevation-0 px-4">
          <v-toolbar-title class="text-subtitle-1 font-weight-bold">
            Advanced filter
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeFilterDialog(true)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <div class="px-8 advanced-filter-dialog">
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="6" class="py-0">
                  <div>Network</div>
                  <div class="text-caption grey--text text--darken-1">
                    Select one of the following conditions
                  </div>
                </v-col>
                <v-col cols="6" class="py-0">
                  <div>
                    <div class="d-flex justify-space-between align-center mb-4">
                      <span class="font-weight-bold text-12">
                        Must match:
                      </span>
                      <v-btn-toggle
                        v-model="selected.networkTagType"
                        active-class="btn-active-btn"
                        class="btn-group"
                        mandatory
                      >
                        <v-btn small class="py-4 px-5 text-capitalize text-11">
                          All tags
                        </v-btn>
                        <v-btn small class="py-4 px-5 text-capitalize text-11">
                          Any tags
                        </v-btn>
                      </v-btn-toggle>
                    </div>

                    <MultipleSelectFilter
                      label="Networks Tags"
                      filterKey="networkTag"
                      url="networks/tags"
                      data-type="string"
                      :selected="selected['networkTag']"
                      @select="select"
                      search
                    />
                  </div>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12">
              <v-divider class="my-2" />
            </v-col>

            <v-col cols="12">
              <v-row>
                <v-col cols="6" class="py-0">
                  <div>Device</div>
                  <div class="text-caption grey--text text--darken-1">
                    Select one of the following conditions
                  </div>
                </v-col>
                <v-col cols="6" class="py-0">
                  <div>
                    <div class="d-flex justify-space-between align-center mb-4">
                      <span class="font-weight-bold text-12">
                        Must match:
                      </span>
                      <v-btn-toggle
                        v-model="selected.deviceTagType"
                        active-class="btn-active-btn"
                        class="btn-group"
                        mandatory
                      >
                        <v-btn small class="py-4 px-5 text-capitalize text-11">
                          All tags
                        </v-btn>
                        <v-btn small class="py-4 px-5 text-capitalize text-11">
                          Any tags
                        </v-btn>
                      </v-btn-toggle>
                    </div>

                    <MultipleSelectFilter
                      label="Device Tags"
                      filterKey="deviceTag"
                      url="devices/tags"
                      data-type="string"
                      :selected="selected['deviceTag']"
                      @select="select"
                      search
                    />
                  </div>

                  <MultipleSelectFilter
                    label="Device Models"
                    filterKey="deviceModel"
                    url="filters/device_models"
                    data-type="string"
                    :selected="selected['deviceModel']"
                    @select="select"
                    search
                    class="mt-4"
                  />

                  <MultipleSelectFilter
                    label="Device Types"
                    filterKey="deviceType"
                    api-primary-key="filterName"
                    api-name-key="displayName"
                    url="filters/device_types"
                    :selected="selected['deviceType']"
                    @select="select"
                    search
                    class="mt-4"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12">
              <v-divider class="my-2" />
            </v-col>

            <v-col cols="12">
              <v-row>
                <v-col cols="6" class="py-0">
                  <div>Status</div>
                </v-col>

                <v-col cols="6" class="py-0">
                  <SingleSelectFilter
                    :items="statusItems"
                    label="Compliance Status"
                    filterKey="complianceStatus"
                    :selected="selected['complianceStatus']"
                    @select="select"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pb-5 text-right mt-2">
              <v-btn
                color="secondary"
                outlined
                class="black--text text-capitalize mr-4"
                @click="closeFilterDialog(true)"
              >
                Cancel
              </v-btn>
              <v-btn
                color="secondary"
                class="button--text text-capitalize"
                @click="closeFilterDialog(false)"
              >
                Done
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex"

import * as _ from 'lodash'

import MultipleSelectFilter from '@/components/filters/MultipleSelectFilter'
import SingleSelectFilter from '@/components/filters/SingleSelectFilter'

export default {
  name: 'FilterGroup',
  components: {
    MultipleSelectFilter,
    SingleSelectFilter
  },
  props: {
    includeAdvancedFilters: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      filterDialog: false,
      selected: {
        showOrgsWithNoDevices: true,
        networkTagType: 0,
        deviceTagType: 0,
      },
      backupSelected: {},
      filteredList: {},
      statusItems: [
        { id: '', name: 'All Statuses' },
        { id: 'active', name: 'Active' },
        { id: 'expired', name: 'Expired' },
      ],
      searchkeyword: null,
    }
  },
  computed: {
    ...mapGetters({
      organizationList: 'organizationList',
    }),

    advancedFilterCount() {
      let count = 0

      if (this.selected['networkTag'] && this.selected['networkTag'].length > 0) {
        count++
      }

      if (this.selected['deviceTag'] && this.selected['deviceTag'].length > 0) {
        count++
      }

      if (this.selected['deviceModel'] && this.selected['deviceModel'].length > 0) {
        count++
      }

      if (this.selected['deviceType'] && this.selected['deviceType'].length > 0) {
        count++
      }

      if (this.selected['complianceStatus'] && this.selected['complianceStatus'].length > 0) {
        count++
      }

      return count
    },

    isFilterSelected() {
      if (this.selected.org && this.selected.org.length > 0) {
        return true
      }

      if (this.selected.network && this.selected.network.length > 0) {
        return true
      }

      if (this.advancedFilterCount) {
        return true
      }

      return true
    }
  },
  methods: {
    showFilterDialog() {
      this.backupSelected = _.cloneDeep(this.selected)
      this.filterDialog = true
    },

    select(selectedItems, filterKey, list = [], isImmediately = false) {
      if (filterKey) {
        this.selected[filterKey] = selectedItems
        this.filteredList[filterKey] = list
      }
      this.selected = JSON.parse(JSON.stringify(this.selected))

      if (isImmediately) {
        this.$emit('select', this.selected);
      }
    },

    closeFilterDialog(isCancel) {
      this.filterDialog = false

      if (isCancel) {
        this.selected = _.cloneDeep(this.backupSelected)
        this.selected = JSON.parse(JSON.stringify(this.selected))
      } else {
        this.$emit('select', this.selected)
      }
    },

    resetFilter() {
      this.selected = {
        networkTagType: 0,
        deviceTagType: 0,
        showOrgsWithNoDevices: true,
      };
      this.$emit('select', this.selected)
    },

    showOrgsWithNoDevices() {
      this.$emit('select', this.selected)
    }
  }
}
</script>

<style lang="scss" scoped>
.selected-filters {
  min-height: 50px;
}

.advanced-filter-dialog {
  .v-btn.v-btn--active.btn-active-btn {
    color: #196FBD;
    text-transform: capitalize;
    border-color: #81BBEE99 !important;
    background-color: rgba(129, 187, 238, 0.3) !important;
    border: 1px solid rgba(129, 187, 238, 0.6);
    box-sizing: border-box;
    border-radius: 4px 0px 0px 4px;
  }

  .v-btn-toggle > .v-btn.v-btn:last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: inherit;
    border-bottom-right-radius: inherit;
  }
}
</style>
